exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".favorite__icon[data-v-5e13c728] {\n  transition: 0.3s color;\n}\n.favorite__icon[data-v-5e13c728]:hover {\n  color: gold;\n}", ""]);

// exports
